import { useState, useEffect, useRef } from 'react';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';

import { AlertNotification } from 'src/shared';
import { i18, trb } from 'src/Utilities';
import { ILoginMessages } from './interfaces';

export const LoginMessage = ({ Message, MsgType }: ILoginMessages) => {
  const { Text } = Typography;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const messageRef = useRef<HTMLDivElement>(null);

  const cleanedInput = Message.replace(/&nbsp;/g, ' ');
  const cleanHTML = DOMPurify.sanitize(cleanedInput);

  useEffect(() => {
    if (messageRef.current) {
      setIsTruncated(messageRef.current.scrollHeight > messageRef.current.clientHeight);
    }
  }, [cleanHTML]);

  return (
    <div className="mb-3">
      <AlertNotification
        description={
          <div>
            <div
              ref={messageRef}
              className={isExpanded ? 'text-justify' : 'text-justify truncate-two-lines'}
              dangerouslySetInnerHTML={{ __html: cleanHTML }}
            />
            {isTruncated && (
              <Text
                className={MsgType === 1 ? 'info_message_button' : 'error_message_button'}
                onClick={() => setIsExpanded((prevState) => !prevState)}
              >
                {trb(i18.Labels[isExpanded ? 'ShowLess' : 'ShowMore'])}
              </Text>
            )}
          </div>
        }
        alertClassName={'mb-2 p-3'}
        type={MsgType === 1 ? 'info' : 'error'}
      />
    </div>
  );
};
